/* eslint no-console:0 */
// This is the entrypoint for the `diner` theme. The files
// imported here will be included on every page of the diner website.
//
// To reference this file, add <%= javascript_pack_tag 'diner' %> to the appropriate
// layout file, like frontend/diner/layouts/application.haml

import 'shared/assets/css'
import 'diner/components/header/header'
import 'diner/components/footer/footer'
import 'diner/components/newsletter_signup/newsletter_signup'
import 'diner/components/event_inquiry/event_inquiry'
import 'diner/components/popup_notification/popup_notification'
import 'diner/components/reservations_cta/reservations_cta'
import 'shared/components'
import 'shared/assets/javascript'
import './css'
import './javascript'
